import React from "react";

import { EEsignatureStatuses } from "../../../../../../constant/EEsignatureStatuses";
import { dateFormatter } from "../../../../../../utils/date";
import { SubmittedFormResultModal } from "../../../../PatientApplications/enrollTab/submission/SubmittedFormResultModal";
import { SaveButton } from "../../../header";
import getPfizerCopayIVSidebarItems from "./sidebarItems";
import { applyTrimFields } from "../../../utils/updateFormData";
import * as pfizerCopayIvFieldNames from "./form/fieldNames";
import { getPfizerCopayIvFormInitialValues } from "./form/initialValues";
import { EE_ERROR_MESSAGES, HEADER_SUBMIT_BUTTON_TYPES } from "../../../constants";
import { CompleteFormButton } from "../../../CompleteFormButton";
import renderReactFromJson from "../../../utils/renderReactFromJson";
import formJson from "./form/PfizerCopayIvFormJson.json";

const pfizerCopayIvConfigurations = {
  getSidebarItems: (t) => getPfizerCopayIVSidebarItems(t),
  activeFormSection: "#enrollment-form-patient",
  formId: "pfizer_copay_iv_smart_editor",
  resultId: "pfizer_copay_iv_enroll_result",
  fieldNames: pfizerCopayIvFieldNames,
  getFormInitialValues: getPfizerCopayIvFormInitialValues,
  // The whole form (incl. the native eligibilityQuestionnaire field) is described declaratively in
  // PfizerCopayIvFormJson.json and rendered via the JSON renderer; modal.js renders it from getFormFromJson.
  getFormFromJson: (form) => renderReactFromJson(form, formJson),
  getViewDetailsModal: (onCancel, visible) => <SubmittedFormResultModal onCancel={onCancel} visible={visible} />,
  applicationFormHeaderSubmission: (props) => <CompleteFormButton id={"EE_IQVIA_submit"} {...props} />,
  headerSubmitButtonType: HEADER_SUBMIT_BUTTON_TYPES.SUBMIT_FORM,
  saveButton: (props) => <SaveButton onSave={(form) => applyTrimFields(form)} id={"EE_IQVIA_save_form"} {...props} />,
  shouldSaveAppear: () => true,
  getShowEnrollResult: (applicationForm) => applicationForm?.status === EEsignatureStatuses.SUBMITTED,
  prepareButtonId: "EE_IQVIA_prepare_application_form",
  resubmitButtonId: "EE_IQVIA_resubmit_application_form",
  viewDetailsButtonId: "EE_IQVIA_view_submission_details",
  applicationSupportsEEId: "application_supports_IQVIA_EE",
  getEnrollResultData: ({ application, applicationForm }) => ({
    group: application.group,
    member_id: application.memberId,
    request_id: application.externalRequestId,
    npi_associated_to_portal: applicationForm.formData.facility.npi,
    bin: application.bin,
    pcn: application.pcn,
    card_activation_date: {
      value: dateFormatter(application.approvedDate),
      style: { marginTop: "44.6px" }
    }
  }),
  getApprovedResultDescription: () => <></>,
  getErrorText: (t, error) => {
    const errorMap = {
      [EE_ERROR_MESSAGES.PRACTICE_NOT_REGISTERED]: "patientApplications.enroll.enroll_result.practice_not_registered",
      [EE_ERROR_MESSAGES.PATIENT_ALREADY_ENROLLED]:
        "patientApplications.enroll.enroll_result.patient_is_already_enrolled",
      [EE_ERROR_MESSAGES.PATIENT_HAS_GOVERNMENT_INSURANCE]:
        "patientApplications.enroll.enroll_result.patient_has_government_insurance"
    };

    return errorMap[error] && t(errorMap[error]);
  },
  approvalDetailsButtonId: "EE_IQVIA_view_approval_details",
  isUseNewResultScreen: false,
  isModalSubmissionEnabled: true
};

export default pfizerCopayIvConfigurations;
